import { RouteObject } from "react-router";
import { lazy } from "react";

// Error pages
const Error403 = lazy(() => import("@/app/pages/errors/403"));

/**
 * Public routes configuration
 * These routes are accessible without authentication
 * Includes error pages, authentication pages, and other public content
 */
const publicRoutes: RouteObject = {
  id: "public",
  children: [
    {
      path: "403",
      Component: Error403,
    },
    {
      path: "create-ticket/:domainCode/:phoneNumber",
      lazy: async () => ({
        Component: (await import("@/app/pages/create-ticket")).default,
      }),
    },
    {
      path: "create-ticket/:domainCode",
      lazy: async () => ({
        Component: (await import("@/app/pages/create-ticket")).default,
      }),
    },
    {
      path: "create-ticket",
      lazy: async () => ({
        Component: (await import("@/app/pages/create-ticket")).default,
      }),
    },
    {
      path: "reopen-ticket/:ticketId/:phoneNumber",
      lazy: async () => ({
        Component: (await import("@/app/pages/reopen-ticket")).default,
      }),
    },
    {
      path: "reopen-ticket/:ticketId",
      lazy: async () => ({
        Component: (await import("@/app/pages/reopen-ticket")).default,
      }),
    },
    {
      path: "reopen-ticket",
      lazy: async () => ({
        Component: (await import("@/app/pages/reopen-ticket")).default,
      }),
    },
  ],
};

export { publicRoutes };
